var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccessTimeFilled = function SvgAccessTimeFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M2.994 15.73C.934 10.756 3.296 5.055 8.27 2.994c4.974-2.06 10.675.302 12.736 5.276 2.06 4.974-.303 10.675-5.276 12.736-4.974 2.06-10.675-.303-12.736-5.276Zm9.474-7.745a.75.75 0 0 0-1.5 0v4.651a.75.75 0 0 0 .36.64l3.656 2.23a.75.75 0 0 0 .78-1.281l-3.296-2.01v-4.23Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccessTimeFilled);
export default ForwardRef;